import React, { useState } from 'react';
import '../styles/Page.css';

function Page() {
    return (
        <div className='page'>
            <div>
                <img src="img/newnew1.jpg" />
                
                <p style={{ textAlign: 'right' }}><i>Collectors Words</i>, 2021. Printing on vinyl, 500x700cm. Artwork for COLLECT NEWNEW LIFE, LCDC, Seoul. </p>
       
                <p> 기간  2021.12.03 Fri. - 2022.01.02 Sun.<br />
                    <br />
                    VIP 오픈 : 2021.12.01 Wed., 12.02 Thu.<br />
                    일시 : 11:00 A.M - 20:00 P.M. (매주 월 휴무)<br />
                    장소 : 서울시 성동구 연무장17길 10, LCDC SEOUL 3층 THE DOORS A301<br />
                    <br />
                    동시대 작가들의 플랫폼 카바 라이프에서 새롭게 선보이는 브랜드 '콜렉트 뉴뉴라이프'의 론칭 전시에 초대합니다.<br />
                    <br />
                    수집가. 오랜 이야기를 새롭게 이어 쓰는 사람이라고 부르니<br />
                    별종, 호기심과 탐방의 외길 인생, 세기와 대륙을 넘나드는 물욕의 집대성이라 답하는 이들.<br />
                    뉴뉴는 첫번째 전시 <i>수집가의 말</i>을 위해 열 명의 수집가들을 만나고, 그들과 나눈 대화를 성수동의 새로운 공간 LCDC에 기록합니다. 디자이너, 기획자, 뮤지션, 요리사, 여행가로서의 삶을 만들어준 진귀하고도 흔하며, 놀랍고도 사소한 수집 생활의 이야기가 이들의 아름답고 진귀한 물건들과 함께 밑도 끝도 없이 펼쳐집니다.
                </p>
                <br />
            </div>
        </div>

    )
}

export default Page;